import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export var Badge = React.forwardRef(function Badge(_a, ref) {
    var _b;
    var _c = _a.theme, theme = _c === void 0 ? "default" : _c, dot = _a.dot, ring = _a.ring, dark = _a.dark, children = _a.children, className = _a.className, props = __rest(_a, ["theme", "dot", "ring", "dark", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    var classSuffix = dark || dot || ring ? "-dark" : "";
    return (React.createElement("span", __assign({ ref: ref, className: classNames(classPrefix + "-badge", className, (_b = {},
            _b[classPrefix + "-badge--radius"] = !dot && !ring,
            _b[classPrefix + "-badge--dot"] = dot && !ring,
            _b[classPrefix + "-badge--ring"] = ring,
            _b["is-blue" + classSuffix] = theme === "default",
            _b["is-success" + classSuffix] = theme === "success",
            _b["is-warning" + classSuffix] = theme === "warning",
            // @ts-ignore
            _b["is-error" + classSuffix] = theme === "danger" || theme === "error",
            _b)) }, props), children));
});
Badge.displayName = "Badge";
//# sourceMappingURL=Badge.js.map